<template>
  <div
    class="wc-dialog-overlay"
    v-if="props.modelValue"
    @click.self="handleClose"
    @touchmove.prevent
    @wheel.prevent
  >
    <div class="task-dialog" @touchmove.stop @wheel.stop>
      <div class="wc-dialog-header">
        <img :src="ruleTitle" class="login-title" />
      </div>
      <div class="wc-dialog-body">
       {{ $t('wc2026.rule.content') }}
      </div>  
    </div>
  </div>

</template>

<script setup>
/* eslint-disable */
import { computed, ref, defineProps, defineEmits, watch, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { toastService } from "@/utils/toastService";
import WcApi from "@/config/wcActApi";

// 禁止/恢复页面滚动
const lockScroll = () => {
  document.body.classList.add('no-scroll')
  document.documentElement.classList.add('no-scroll')
}

const unlockScroll = () => {
  document.body.classList.remove('no-scroll')
  document.documentElement.classList.remove('no-scroll')
}


import ruleTitleVi from "@/assets/imgs/act/wc2026/ruleDialog/titlevi.png";
import ruleTitleTh from "@/assets/imgs/act/wc2026/ruleDialog/titleth.png";
import ruleTitleId from "@/assets/imgs/act/wc2026/ruleDialog/titleid.png";
import ruleTitleZh from "@/assets/imgs/act/wc2026/ruleDialog/titlezh.png";
import ruleTitleEn from "@/assets/imgs/act/wc2026/ruleDialog/titleen.png";
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  taskList: { type: Array, default: () => [] },
});
const locale = useI18n().locale
const ruleTitle = computed(() => {

  switch (locale.value) {
    case "vi":
      return ruleTitleVi;
    case "th":
      return ruleTitleTh;
    case "id":
      return ruleTitleId;
    case "en":
      return ruleTitleEn;
    case "tw":
      return ruleTitleZh;
    case "hk":
      return ruleTitleZh;
    default:
      return ruleTitleEn;
  }
});
const emit = defineEmits(["update:modelValue", "received", "refreshActivity"]);
const { t } = useI18n();

const showShareDialog = ref(false);

const handleClose = () => {
  emit("update:modelValue", false);
};

const sortedTaskList = computed(() => {
  const order = { 1: 0, 0: 1, 2: 2 };
  return [...props.taskList].sort(
    (a, b) => (order[a.status] ?? 3) - (order[b.status] ?? 3),
  );
});

const getTaskBtnClass = (item) => {
  if (item.status === 1) return "can-receive";
  if (item.status === 2) return "received";
  return "not-done";
};

const getTaskBtnText = (item) => {
  if (item.status === 0) return t("wc2026.notReach");
  if (item.status === 1) return t("wc2026.canReceive");
  return t("wc2026.received");
};

const handleReceive = async (item) => {
  if (item.status !== 1) return;
  try {
    const res = await WcApi.receiveTaskReward({ taskType: item.taskType });
    emit("received", { taskType: item.taskType, balance: res.balance });
    emit("refreshActivity");
    item.status = 2;
    toastService.showSmall(t("mwr.mission.receiveRewardSuccess"));
  } catch (e) {
    console.error(e);
  }
};

const handleViewTask = (item) => {
  if (item.taskType === 'wc_weekly_share') {
    showShareDialog.value = true;
    handleClose()
    setTimeout(() => {
      WcApi.reportShare({
        shareType: 'wc_weekly_share',
      })
    }, 5000);
  }
};

const onShareSuccess = () => {
  emit("refreshActivity");
  emit("received", { taskType: 'wc_weekly_share' });
};

watch(() => props.modelValue, (val) => {
  if (val) {
    lockScroll()
  } else {
    unlockScroll()
  }
}, { immediate: true })

onUnmounted(() => {
  unlockScroll()
})
</script>

<style lang="less" scoped>
@import "../shared.less";

.task-dialog {
  width: 673px;
  height: 439px;
  background-image: url("~@/assets/imgs/act/wc2026/dialog/bg.png");

  .wc-dialog-body {
    overflow-y: auto;
    white-space: pre-wrap;
    flex: 1;
    height: 320px;
    padding: 0 30px;
    line-height: 1.3;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar-thumb {
      background: #FEDA41;
    }
    &::-webkit-scrollbar-track {
      background: #36345C;
    }
  }
  font-size: 24px;
}
.login-title {
  height: 41px;
  width: auto;
  display: block;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 29px;
}

</style>
